// export const API = "http://192.168.11.54:5050/api"
// export const API = "https://api.dealdirecthomes.com/api"
export const API = "https://api.dealdirecthomes.com/api"
export const CHAT_API = "https://api.dealdirecthomes.com"
// export const API = "http://192.168.18.16:5050/api"
// export const API = "http://192.168.18.42:5050/api"
// export const API = "http://localhost:5050/api"

// export const SEARCH_API = "http://192.168.18.16:8000/scrapper/api/scrape/"
export const SEARCH_API = "https://scraper.dealdirecthomes.com/scrapper/api/scrape/"
// export const API = "http://localhost:5050/api"
